import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Grid, Switch } from '@mui/material';
import { LwFormSelect } from 'redesign';
import { useTranslation } from 'react-i18next';
import type { WorkFormContext } from '../work-form.types';
import { NIGHT_SHIFT_LIMITATION_SYSTEM } from '../../forms/inputs/rest-rule.types';

const nightShiftOptions = [
  {
    value: NIGHT_SHIFT_LIMITATION_SYSTEM.SHIFTS_PER_16_WEEKS,
    label: 'Maximaal 43 nachtdiensten per 16 weken',
  },
  {
    value: NIGHT_SHIFT_LIMITATION_SYSTEM.HOURS_PER_2_WEEKS,
    label: 'Maximaal 20 nachturen per 2 weken',
  },
];

export const RestTimeRule = () => {
  const { control, watch } = useFormContext<WorkFormContext>();
  const { t } = useTranslation('web-common');

  const shouldAdhereToRestRules = watch('shouldAdhereToDrivingRestRules');

  return (
    <Grid container item columnSpacing={4} xs={12}>
      <Grid item xs={12}>
        <Controller
          name="shouldAdhereToDrivingRestRules"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={<Switch {...field} checked={!!field.value} />}
              label={t('work_form.shouldAdhereToDrivingRestRules', { ns: 'web-common' })}
            />
          )}
        />
      </Grid>

      {shouldAdhereToRestRules ? (
        <Grid item xs={12} mt={2}>
          <LwFormSelect
            name="nightShiftLimitationSystem"
            label={t('work_form.nightShiftLimitationSystem', { ns: 'web-common' })}
            control={control}
            options={nightShiftOptions}
            rules={{
              required: t('work_form.nightShiftLimitationSystemRequired.error', {
                ns: 'web-common',
              }),
            }}
          />
        </Grid>
      ) : null}
    </Grid>
  );
};
